<img *ngIf="isInView()" [src]="src" (load)="onLoad()" [style.visibility]="loaded ? 'visible' : 'hidden'" />
<loader *ngIf="!loaded"></loader>
